import {
  IonIcon,
  IonItem,
  IonLabel,
  IonModal,
  IonButton,
  IonText,
} from "@ionic/react";
import { leafOutline } from "ionicons/icons";
import React, { useState } from "react";
import "./WASprout.css";

function WASprout() {
  const [showModal, setShowModal] = useState(false);

  return (
    <div>
      <IonItem className="ion-hide-sm-down">
        <IonIcon icon={leafOutline} slot="start" className="ion-icon" />
        <IonLabel className="ion-text-wrap">
          Semifinalist, Sprout | Chicago Booth SNVC 2020{" "}
        </IonLabel>

        <IonModal isOpen={showModal} className="ion-modal-popup">
          <IonText className="ion-justify-content-center ion-align-items-center ion-margin">
            <br />
            <b>Semifinalist, Sprout | Chicago Booth SNVC 2020 </b>
            <br />
            <p>
              During the semi-finals of the 2020 Chicago Booth Social New
              Venture Challenge, I developed one of the first comprehensive
              database of all non-profits in the Chicagoland area using{" "}
              <code>Python, SQL, and APIs</code>. I also prototyped a hybrid
              recommendation algorithm in <code>Python</code> for social-impact
              startup to match high-net-worth individuals with nonprofits in
              Chicago, increasing visibility and funding for under-detected
              nonprofits.
            </p>
            <br />
            <em>No demo available</em>
            <br />
            <IonButton
              className="ion-button"
              onClick={() => setShowModal(false)}
            >
              Close
            </IonButton>

            <br />
          </IonText>
        </IonModal>

        <IonButton className="ion-button" onClick={() => setShowModal(true)}>
          Show
        </IonButton>
      </IonItem>
    </div>
  );
}

export default WASprout;
